export enum PedidoEntregaTypes {
  'LOAD_REQUEST' = '@pedidoEntrega/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@pedidoEntrega/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@pedidoEntrega/LOAD_FAILURE',

  'CLEAN_PEDIDO' = '@pedidoEntrega/CLEAN_PEDIDO',
}

export interface IPedidoReq {
  chaveNfe?: string;
  codCdd: number;
  codDestinatario: number;
  codFornecedor: number;
  codTomador: number;
  codTransportadora: number;
  clienteEntrega: boolean;
  valor: number;
  numNota: number;
  pesoBruto: number;
  codCidadeOrigem?: number;
  observacao?: string;
  tipoVolume: string;
  qtdVolume: number;
}

export interface IRequest {
  pedido: IPedidoReq;
  nomeArquivo?: string;
  chave?: string;
}

export interface IPedidoRes {
  codCentroDistribuicao: number;
  codFornecedor: number;
  fornecedor: string;
  numNota: number;
  codDestinatario: number;
  destinatario: string;
  pesoBruto: number;
  valor: number;
  observacao: string;
  status: string;
  nuNota: number;
  codTomador: number;
  codTransportadora: number;
  tomador: string;
  transportadora: string;
  codCidadeOrigem: number;
  cidadeOrigem: string;
  tipoVolume: string;
  qtdVolume: number;
  chaveNfe: string;
}

export interface PedidoEntregaState {
  readonly data: IPedidoRes[];
  readonly loadingPedidoEntrega: boolean;
  readonly error: boolean;
}
